import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-white">
      <nav className="bg-white border-b border-gray-200 sticky top-0 z-50">
        <div className="container mx-auto px-6 py-4">
          <Link to="/" className="flex items-center gap-2 text-gray-600 hover:text-[#2d5f3f]">
            <ArrowLeft className="w-5 h-5" />
            <span className="font-medium">Torna alla Home</span>
          </Link>
        </div>
      </nav>

      <div className="container mx-auto px-6 py-12 max-w-4xl">
        <h1 className="text-4xl font-bold mb-8" style={{ color: '#0a3d2a' }}>
          Privacy Policy
        </h1>

        <div className="prose prose-lg max-w-none">
          <p className="text-gray-600 mb-6">
            <strong>Alt Bollette SRL</strong> con sede legale in Corso Mazzini 76, 48022 Lugo (RA), 
            in qualità di Titolare del trattamento, La informa ai sensi dell'art. 13 del Regolamento 
            UE 2016/679 (GDPR) che i Suoi dati personali saranno trattati con le modalità e per le 
            finalità seguenti.
          </p>

          <h2 className="text-2xl font-bold mt-8 mb-4" style={{ color: '#0a3d2a' }}>
            1. Finalità del trattamento
          </h2>
          <p className="text-gray-600 mb-4">
            I dati personali da Lei forniti attraverso il form di contatto saranno trattati per le 
            seguenti finalità:
          </p>
          <ul className="list-disc pl-6 text-gray-600 mb-6">
            <li>Rispondere alle Sue richieste di informazioni e consulenza</li>
            <li>Fornire preventivi personalizzati per soluzioni energetiche</li>
            <li>Gestire la relazione pre-contrattuale e contrattuale</li>
            <li>Adempiere agli obblighi previsti da leggi e regolamenti</li>
          </ul>

          <h2 className="text-2xl font-bold mt-8 mb-4" style={{ color: '#0a3d2a' }}>
            2. Base giuridica del trattamento
          </h2>
          <p className="text-gray-600 mb-6">
            Il trattamento dei Suoi dati personali si fonda sul Suo consenso esplicito (art. 6, 
            comma 1, lett. a GDPR) e sull'esecuzione di misure precontrattuali adottate su Sua 
            richiesta (art. 6, comma 1, lett. b GDPR).
          </p>

          <h2 className="text-2xl font-bold mt-8 mb-4" style={{ color: '#0a3d2a' }}>
            3. Dati raccolti
          </h2>
          <p className="text-gray-600 mb-4">
            Attraverso il nostro sito web raccogliamo le seguenti categorie di dati:
          </p>
          <ul className="list-disc pl-6 text-gray-600 mb-6">
            <li>Dati anagrafici (nome e cognome)</li>
            <li>Dati di contatto (email, telefono)</li>
            <li>Dati di localizzazione (comune e provincia)</li>
            <li>Informazioni relative alle Sue esigenze energetiche</li>
          </ul>

          <h2 className="text-2xl font-bold mt-8 mb-4" style={{ color: '#0a3d2a' }}>
            4. Modalità del trattamento
          </h2>
          <p className="text-gray-600 mb-6">
            I dati personali sono trattati con strumenti informatici e manuali, con logiche 
            strettamente correlate alle finalità sopra indicate e, comunque, in modo da garantire 
            la sicurezza e la riservatezza dei dati stessi.
          </p>

          <h2 className="text-2xl font-bold mt-8 mb-4" style={{ color: '#0a3d2a' }}>
            5. Destinatari dei dati
          </h2>
          <p className="text-gray-600 mb-6">
            I Suoi dati personali potranno essere comunicati a:
          </p>
          <ul className="list-disc pl-6 text-gray-600 mb-6">
            <li>Personale interno autorizzato al trattamento</li>
            <li>Consulenti e collaboratori esterni (commercialisti, consulenti legali)</li>
            <li>Fornitori di servizi tecnici (hosting, manutenzione sito web)</li>
            <li>Autorità competenti per adempimenti di legge</li>
          </ul>

          <h2 className="text-2xl font-bold mt-8 mb-4" style={{ color: '#0a3d2a' }}>
            6. Periodo di conservazione
          </h2>
          <p className="text-gray-600 mb-6">
            I dati personali saranno conservati per il tempo strettamente necessario al 
            conseguimento delle finalità per le quali sono stati raccolti. In particolare:
          </p>
          <ul className="list-disc pl-6 text-gray-600 mb-6">
            <li>Per richieste di informazione: fino a 12 mesi dalla richiesta</li>
            <li>Per rapporti contrattuali: per tutta la durata del rapporto e successivamente per i termini di legge</li>
          </ul>

          <h2 className="text-2xl font-bold mt-8 mb-4" style={{ color: '#0a3d2a' }}>
            7. Diritti dell'interessato
          </h2>
          <p className="text-gray-600 mb-4">
            In qualità di interessato, Lei ha il diritto di:
          </p>
          <ul className="list-disc pl-6 text-gray-600 mb-6">
            <li>Accedere ai Suoi dati personali</li>
            <li>Ottenere la rettifica o la cancellazione degli stessi</li>
            <li>Ottenere la limitazione del trattamento</li>
            <li>Opporsi al trattamento</li>
            <li>Richiedere la portabilità dei dati</li>
            <li>Revocare il consenso in qualsiasi momento</li>
            <li>Proporre reclamo all'Autorità di controllo (Garante Privacy)</li>
          </ul>

          <h2 className="text-2xl font-bold mt-8 mb-4" style={{ color: '#0a3d2a' }}>
            8. Conferimento dei dati
          </h2>
          <p className="text-gray-600 mb-6">
            Il conferimento dei dati è facoltativo ma necessario per rispondere alle Sue richieste. 
            Il mancato conferimento comporta l'impossibilità di fornirLe i servizi richiesti.
          </p>

          <h2 className="text-2xl font-bold mt-8 mb-4" style={{ color: '#0a3d2a' }}>
            9. Contatti
          </h2>
          <p className="text-gray-600 mb-6">
            Per esercitare i Suoi diritti o per qualsiasi informazione relativa al trattamento 
            dei dati personali può contattare il Titolare del trattamento:
          </p>
          <div className="bg-gray-50 p-6 rounded-lg mb-6">
            <p className="text-gray-700 font-semibold mb-2">Alt Bollette SRL</p>
            <p className="text-gray-600">Corso Mazzini 76, 48022 Lugo (RA)</p>
            <p className="text-gray-600">Email: amministrazione@altbollette.info</p>
            <p className="text-gray-600">Telefono: +39 350 148 3135</p>
          </div>

          <p className="text-sm text-gray-500 mt-8">
            Ultimo aggiornamento: Dicembre 2024
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
